/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type McsBookingRequest,
    McsBookingRequestFromJSON,
    McsBookingRequestToJSON,
} from '../models/McsBookingRequest';
import {
    type McsConfigResponse,
    McsConfigResponseFromJSON,
    McsConfigResponseToJSON,
} from '../models/McsConfigResponse';
import {
    type PreBookingResponse,
    PreBookingResponseFromJSON,
    PreBookingResponseToJSON,
} from '../models/PreBookingResponse';

export interface CreateMcsBookingRequest {
    mcsBookingRequest: McsBookingRequest;
}

export interface GetMcsConfigRequest {
    locationId: number;
}

/**
 * 
 */
export class McsControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for createMcsBooking without sending the request
     */
    async createMcsBookingRequestOpts(requestParameters: CreateMcsBookingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['mcsBookingRequest'] == null) {
            throw new runtime.RequiredError(
                'mcsBookingRequest',
                'Required parameter "mcsBookingRequest" was null or undefined when calling createMcsBooking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/external/prebooking/mcs`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: McsBookingRequestToJSON(requestParameters['mcsBookingRequest']),
        };
    }

    /**
     * Create an MCS (Monthly Car Subscription) prebooking
     */
    async createMcsBookingRaw(requestParameters: CreateMcsBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreBookingResponse>> {
        const requestOptions = await this.createMcsBookingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreBookingResponseFromJSON(jsonValue));
    }

    /**
     * Create an MCS (Monthly Car Subscription) prebooking
     */
    async createMcsBooking(requestParameters: CreateMcsBookingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreBookingResponse> {
        const response = await this.createMcsBookingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getMcsConfig without sending the request
     */
    async getMcsConfigRequestOpts(requestParameters: GetMcsConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getMcsConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/external/prebooking/mcs/config/{locationId}`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get MCS configuration for a specific location
     */
    async getMcsConfigRaw(requestParameters: GetMcsConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<McsConfigResponse>> {
        const requestOptions = await this.getMcsConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => McsConfigResponseFromJSON(jsonValue));
    }

    /**
     * Get MCS configuration for a specific location
     */
    async getMcsConfig(requestParameters: GetMcsConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<McsConfigResponse> {
        const response = await this.getMcsConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
